var _rect, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionRedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 190,
    height: 190,
    viewBox: "0 0 190 190",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.9,
    width: 144.309,
    height: 143.824,
    rx: 23,
    transform: "matrix(0.940174 0.340694 -0.34335 0.939207 54.3114 0)",
    fill: "#FF2F48"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_3824_57)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 45.8711,
    width: 144.129,
    height: 144.129,
    rx: 23,
    fill: "url(#paint0_radial_3824_57)",
    fillOpacity: 0.62
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_3824_57)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.8716 140.936C68.031 140.936 66.5426 139.447 66.5426 137.607C66.5426 133.252 67.1602 129.491 68.3893 126.329C69.291 123.945 70.7548 121.542 72.7682 119.115C74.2505 117.349 76.9063 114.767 80.7479 111.382C84.5896 107.992 87.0848 105.293 88.2397 103.279C89.3947 101.266 89.9629 99.0669 89.9629 96.6829C89.9629 92.3657 88.2768 88.5796 84.9107 85.3124C81.5447 82.0452 77.4128 80.4146 72.5212 80.4146C67.7963 80.4146 63.8497 81.8969 60.6875 84.8554C58.3776 87.017 56.642 90.0681 55.4932 94.0086C54.7027 96.7138 52.0654 98.4431 49.2676 98.1096C45.7224 97.6896 43.3878 94.1815 44.4007 90.7537C45.9571 85.4853 48.5635 81.2422 52.2137 78.0182C57.2844 73.5281 63.9918 71.2861 72.3359 71.2861C81.1679 71.2861 88.215 73.6887 93.4772 78.5C98.7394 83.3113 101.364 89.1231 101.364 95.9417C101.364 99.8883 100.438 103.526 98.5911 106.849C96.7444 110.178 93.1251 114.223 87.7456 118.991C84.1325 122.197 81.767 124.562 80.6553 126.082C79.5436 127.601 78.7221 129.349 78.191 131.319C77.7957 132.783 77.5239 134.932 77.3757 137.755C77.2831 139.534 75.8069 140.93 74.0282 140.93H69.8716V140.936ZM65.9249 156.87C65.9249 153.381 68.7537 150.552 72.2432 150.552C75.7328 150.552 78.5615 153.381 78.5615 156.87C78.5615 160.36 75.7328 163.189 72.2432 163.189C68.7537 163.189 65.9249 160.36 65.9249 156.87Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.3716 141.436H69.8716C67.7549 141.436 66.0426 139.723 66.0426 137.607C66.0426 133.208 66.6661 129.383 67.9224 126.15C68.848 123.704 70.3439 121.254 72.3834 118.796L72.3852 118.794C73.8932 116.997 76.573 114.394 80.4171 111.007C84.255 107.62 86.6951 104.967 87.806 103.03C88.9157 101.096 89.4629 98.9835 89.4629 96.6829C89.4629 92.5138 87.8412 88.8536 84.5625 85.6712C81.2943 82.4989 77.2892 80.9146 72.5212 80.9146C67.9108 80.9146 64.09 82.3568 61.0291 85.2204C58.8011 87.3055 57.1041 90.2697 55.9733 94.1485L55.9732 94.1488C55.1136 97.0901 52.2473 98.9681 49.2088 98.6061C45.3586 98.15 42.8197 94.3395 43.9212 90.612C45.5008 85.2652 48.1535 80.9374 51.8824 77.6437C57.0646 73.055 63.8995 70.7861 72.3359 70.7861C81.2615 70.7861 88.4395 73.2164 93.8146 78.131C99.1752 83.0323 101.864 88.9759 101.864 95.9417C101.864 99.97 100.918 103.692 99.0284 107.092C97.1394 110.497 93.4681 114.588 88.0773 119.366C84.4622 122.573 82.135 124.906 81.0588 126.377C79.9865 127.843 79.1903 129.533 78.6737 131.449L78.6737 131.45C78.2924 132.862 78.0227 134.969 77.875 137.781L70.3716 141.436ZM70.3716 141.436V141.43M70.3716 141.436V141.43M70.3716 141.43H74.0282C76.072 141.43 77.7684 139.826 77.875 137.781L70.3716 141.43ZM72.2432 150.052C68.4775 150.052 65.4249 153.105 65.4249 156.87C65.4249 160.636 68.4775 163.689 72.2432 163.689C76.009 163.689 79.0615 160.636 79.0615 156.87C79.0615 153.105 76.009 150.052 72.2432 150.052Z",
    stroke: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_3824_57",
    x: -3,
    y: 42.8711,
    width: 150.129,
    height: 150.129,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_3824_57"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_3824_57",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_3824_57",
    x: 43.1622,
    y: 70.2861,
    width: 68.62,
    height: 103.321,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.709,
    dy: 4.709
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.3545
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3824_57"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3824_57",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3824_57",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(72.0644 117.935) rotate(90) scale(79.2708)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA6BA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA6BA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionRedIcon);
export default __webpack_public_path__ + "static/media/question-red-icon.8772764bb56332813f30f9d30d1edd8c.svg";
export { ForwardRef as ReactComponent };